import React from "react";
import PropTypes from "prop-types";
import { withStyles } from "material-ui/styles";
import AppBar from "material-ui/AppBar";
import Toolbar from "material-ui/Toolbar";
import Typography from "material-ui/Typography";
import Avatar from "material-ui/Avatar";
import Logo from "./happynourlogo.jpg";
import classNames from "classnames";

const styles = {
  root: {
    width: "100%"
  },
  avatar: {
    margin: 10
  },
  bigAvatar: {
    width: 60,
    height: 60
  }
};

function Header(props) {
  const { classes } = props;
  return (
    <div className={classes.root}>
      <AppBar position="static" color="inherit">
        <Toolbar>
          <Avatar
            src={Logo}
            style={{
              borderRadius: 0,
              backgroundColor: "white"
              //border: "1px solid lightgray"
            }}
            aria-label="Happy Nour"
            className={classNames(classes.avatar, classes.bigAvatar)}
          />

          <Typography type="subheading" color="inherit">
            &nbsp;Walnut Creek, CA
          </Typography>
        </Toolbar>
      </AppBar>
      <br />
    </div>
  );
}

Header.propTypes = {
  classes: PropTypes.object.isRequired
};

export default withStyles(styles)(Header);



// WEBPACK FOOTER //
// ./src/Layout/Header/index.js